/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_Bddk_AInputs */

const tr_mesafeli_s6_bddk_a = /** @type {(inputs: Mesafeli_S6_Bddk_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri, seçtiği abonelik planının bedelini dönem başında kredi veya banka kartıyla ya da havale/EFT ile tek seferde öder. Kart bilgileri Sağlayıcı tarafından saklanmaz ve Müşteri'nin kartından`)
};

const en_mesafeli_s6_bddk_a = /** @type {(inputs: Mesafeli_S6_Bddk_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Customer pays the price of the chosen subscription plan in a single amount by credit or debit card or by bank transfer/EFT at the start of the term. Card details are not stored by the Provider, and from the Customer's card`)
};

const de_mesafeli_s6_bddk_a = /** @type {(inputs: Mesafeli_S6_Bddk_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Kunde zahlt den Preis des gewählten Tarifs zu Beginn der Laufzeit in einem Betrag per Kredit- oder Bankkarte oder per Überweisung/EFT. Kartendaten werden vom Anbieter nicht gespeichert, und von der Karte des Kunden erfolgt`)
};

const ru_mesafeli_s6_bddk_a = /** @type {(inputs: Mesafeli_S6_Bddk_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Клиент оплачивает стоимость выбранного плана подписки в начале срока одним платежом кредитной или дебетовой картой либо банковским переводом/EFT. Данные карты Поставщиком не сохраняются, и с карты Клиента`)
};

/**
* | output |
* | --- |
* | "The Customer pays the price of the chosen subscription plan in a single amount by credit or debit card or by bank transfer/EFT at the start of the term. Card..." |
*
* @param {Mesafeli_S6_Bddk_AInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_bddk_a = /** @type {((inputs?: Mesafeli_S6_Bddk_AInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_Bddk_AInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_bddk_a(inputs)
	if (locale === "de") return de_mesafeli_s6_bddk_a(inputs)
	if (locale === "ru") return ru_mesafeli_s6_bddk_a(inputs)
	return tr_mesafeli_s6_bddk_a(inputs)
});